import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { Column, Row } from 'shared';

import { SinglePage } from './singlePage/SinglePage';
import { BoxWrapper, PageBackgroundBox } from './StaticPages.styles';
import { StaticPagesProps } from './StaticPages.types';

export const StaticPages = ({ onFetchStaticPage, onFetchStaticPageBySlug }: StaticPagesProps) => {
  const onFetchPage = (type: string) => () => onFetchStaticPage(type);

  return (
    <Row height="100%">
      <Column>
        <PageBackgroundBox px={[1, 2, 2, 6]} className="page-wrapper">
          <Row>
            <Column size={[0, 0, 2]} />
            <Column size={[12, 12, 7]} py="2rem">
              <BoxWrapper className="page-wrapper__content">
                <Routes>
                  <Route
                    path="privacy-policy/*"
                    element={<SinglePage key="PRIVACY" onFetchPage={onFetchPage('PRIVACY')} />}
                  />
                  <Route
                    path="cookies-policy/*"
                    element={<SinglePage key="COOKIES" onFetchPage={onFetchPage('COOKIES')} />}
                  />
                  <Route
                    path="service-policy/*"
                    element={<SinglePage key="STATUTE" onFetchPage={onFetchPage('STATUTE')} />}
                  />
                  <Route
                    path=":slug/*"
                    element={<SinglePageBySlug onFetchStaticPageBySlug={onFetchStaticPageBySlug} />}
                  />
                  <Route path="*" element={<Navigate to="/" replace={true} />} />
                </Routes>
              </BoxWrapper>
            </Column>
            <Column size={[0, 0, 3]} />
          </Row>
        </PageBackgroundBox>
      </Column>
    </Row>
  );
};

const SinglePageBySlug = ({ onFetchStaticPageBySlug }: Pick<StaticPagesProps, 'onFetchStaticPageBySlug'>) => {
  const { slug } = useParams();

  return slug ? <SinglePage key={slug} onFetchPage={() => onFetchStaticPageBySlug(slug)} /> : null;
};
